import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiManagersMeetingNoteMutateType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    title: string;
    content: RawDraftContentState;
    postDate: string;
    meetingNoteTemplateId?: string;
    attachFiles?: File[];
    participationEmployeeIds: string[];
    businessSectionIds: string[];
  };
};

const request = ({ id, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ meetingNote: body });
  return new ApiClient()
    .put<ApiManagersMeetingNoteMutateType>(
      `/api/managers/meeting_notes/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersMeetingNotesUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersMeetingNoteMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
